import { colors } from '../../theme/colors'
import { ColorsConstants } from './Colors.constants'
import type { ColorPattern, ColorPatternName } from './Colors.types'

/** Design max for a single qualitative palette (9+1 rule). */
export const COLOR_MAX_DISTINCT = 10

export const COLOR_PATTERNS: Readonly<Record<ColorPatternName, ColorPattern>> =
  {
    'qualitative.default': {
      intent: 'qualitative',
      background: 'either',
      maxDistinct: COLOR_MAX_DISTINCT,
      highlight: ColorsConstants.defaultHighlight,
      colors: colors.chart.palette.slice(0, COLOR_MAX_DISTINCT),
    },
    'qualitative.neutral': {
      intent: 'qualitative',
      background: 'either',
      maxDistinct: COLOR_MAX_DISTINCT,
      highlight: ColorsConstants.defaultHighlight,
      colors: [
        colors.presets.neutral['40'],
        colors.presets.neutral['50'],
        colors.presets.neutral['60'],
        colors.presets.neutral['70'],
        colors.presets.neutral['80'],
        colors.presets.neutral['90'],
        colors.presets.neutral['30'],
        colors.presets.neutral['20'],
        colors.presets.neutral['100'],
        colors.presets.neutral['10'],
      ],
    },
    'qualitative.brand': {
      intent: 'qualitative',
      background: 'either',
      maxDistinct: COLOR_MAX_DISTINCT,
      highlight: ColorsConstants.defaultHighlight,
      colors: [
        colors.presets.turquoise['30'],
        colors.presets.blue['50'],
        colors.presets.turquoise['50'],
        colors.presets.blue['80'],
        colors.presets.turquoise['70'],
        colors.presets.blue['40'],
        colors.presets.turquoise['40'],
        colors.presets.blue['90'],
        colors.presets.turquoise['90'],
        colors.presets.blue['60'],
      ],
    },
    'sequential.default': {
      intent: 'sequential',
      background: 'light',
      highlight: ColorsConstants.defaultHighlight,
      colors: [
        colors.presets.turquoise['10'],
        colors.presets.turquoise['20'],
        colors.presets.turquoise['30'],
        colors.presets.turquoise['40'],
        colors.presets.turquoise['50'],
        colors.presets.turquoise['60'],
        colors.presets.turquoise['70'],
        colors.presets.turquoise['80'],
        colors.presets.turquoise['90'],
        colors.presets.turquoise['100'],
      ],
    },
    'semantic.default': {
      intent: 'semantic',
      background: 'either',
      highlight: ColorsConstants.defaultHighlight,
      colors: [
        colors.goalColors.goodTurquoise,
        colors.goalColors.badPink,
        colors.presets.red['55'],
        colors.goalColors.neutralGray,
      ],
      roles: {
        positive: colors.goalColors.goodTurquoise,
        negative: colors.goalColors.badPink,
        critical: colors.presets.red['55'],
        neutral: colors.goalColors.neutralGray,
      },
    },
  }
